import { executeGql, processGqlResult } from '../../utils/gql-utils';

const venueGetPaymentMethodUpdateSessionQuery = /* GraphQL */ `
  query venueGetPaymentMethodUpdateSession {
    venueGetPaymentMethodUpdateSession
  }
`;

export const venueGetPaymentMethodUpdateSessionApi = async (): Promise<string> => {
  const result = await executeGql<string>(venueGetPaymentMethodUpdateSessionQuery);
  return processGqlResult<string>('venueGetPaymentMethodUpdateSession', result);
};
